<h2 mat-dialog-title>
  <span>{{'RESET-PASSWORD' | translate }}</span>
</h2>
<mat-dialog-content class="mat-typography">
  <form #putProduct="ngForm">

    <!--  ************************************  -->
    <!--                USERNAME                -->
    <!--  ************************************  -->
    <mat-form-field class="fullWidthField">
      <mat-label>{{'INSERT-MAIL' | translate }}</mat-label>
      <input matInput #userName="ngModel" name="username" [(ngModel)]="username">
    </mat-form-field>
  </form>
</mat-dialog-content>


<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null">{{'CLOSE' | translate }}</button>
  <button mat-button class="primaryButton" [disabled]="putProduct.invalid" (click)="resetPassword()">{{'RESET' | translate }}</button>
</mat-dialog-actions>
